import Vue from 'vue'
import to from 'await-to-js'
import store from './vuex'
import { getI18nInstance } from './vue-i18n'
import './axios'
import './rollbar'
import LazyLoadDirective from '@/directives/lazyload'
import DataTestIdDirective from '@/directives/data-test-id'
import MultiRefDirective from '@/directives/multi-ref'
import { registerStores } from '@/helpers/stores'
import { ExternalCommunicationPlugin } from '@/services/external-communication/external-communication'

Vue.directive('lazyload', LazyLoadDirective)
Vue.directive('data-test-id', DataTestIdDirective)
Vue.directive('multi-ref', MultiRefDirective)
Vue.use(ExternalCommunicationPlugin)

Vue.filter('formattedCurrency', (number, locale, currency, minimumFractionDigits = 2) => {
  let result = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits,
  }).format(number)
  return result
})

const defaultOptions = {
  render: null, // Function to render the component: h => h(MyComponent)
  mount: null, // Selector to mount the vue instance in
  stores: [], // Stores to create
}

async function newVue(params, callback) {
  const options = { ...defaultOptions, ...params }
  const vueOptions = {
    render: options.render,
    router: options.router,
    i18n: getI18nInstance(),
  }
  await createStores(options.stores)
  vueOptions.store = store

  const vm = new Vue(vueOptions)
  vm.$mount(options.mount)
  if (callback) callback(vm)

  return vm
}

async function createStores(storeList) {
  const stores = {}
  for (let i = 0; i < storeList.length; i++) {
    const store = storeList[i]
    const [err, imported] = await to(import(/* webpackMode: "eager" */ `@/stores/${store}`))
    if (err) throw `Unable to find the file '@/stores/${store}' specified in 'stores' setting.`
    stores[store] = imported.default
    stores[store].state = stores[store].state || {}
  }
  registerStores(stores)
}

export { Vue, newVue }
